import type { RumLike } from './rumErrorLogger';

/**
 * Provides SSR-safe access to the client registered by `datadogRum.ts`.
 *
 * Keep this registry separate from the initializer. Importing `datadogRum.ts` evaluates
 * its static `@datadog/browser-rum` import, which would pull the browser SDK into universal
 * feature modules and the server dependency graph.
 */
let rumClient: RumLike | undefined;

export const setRumClient = (client: RumLike | undefined): void => {
    rumClient = client;
};

export const getRumClient = (): RumLike | undefined => rumClient;
